import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';
import { ICON_SIZE } from './constants.js';

function Label({ isActive, label, icon, iconSize, notificationIndicator }) {
    return (jsxs(Wrapper, { children: [jsx(IconSlot, { "$iconSize": iconSize, "$isActive": isActive, children: icon }), jsxs(StyledLabel, { "$isActive": isActive, children: [label, Boolean(notificationIndicator) && notificationIndicator] })] }));
}
const Wrapper = styled("div")({
    display: "flex",
});
const StyledLabel = styled(Typography)(({ theme, $isActive }) => (Object.assign({ position: "relative", fontSize: 14, fontWeight: 400, lineHeight: "24px" }, ($isActive && {
    color: theme.palette.text.dhigh,
}))));
const IconSlot = styled("div")(({ theme, $isActive, $iconSize }) => (Object.assign({ height: $iconSize !== null && $iconSize !== void 0 ? $iconSize : ICON_SIZE, width: $iconSize !== null && $iconSize !== void 0 ? $iconSize : ICON_SIZE, marginRight: theme.spacing(1.5) }, ($isActive && {
    color: theme.palette.text.dhigh,
}))));

export { Label };
//# sourceMappingURL=Label.js.map
